import { Extension } from '@tiptap/core';
import { ZyStudioInstructionNode, ZyStudioInstructionNodeHeadless, ZyStudioNode, ZyStudioNodeHeadless } from './zystudio-extension';

export const ZyStudioHeadless = Extension.create({
    name: 'zyStudioWrapper',

    addExtensions() {
        return [ZyStudioInstructionNodeHeadless, ZyStudioNodeHeadless];
    },

    addProseMirrorPlugins() {
        return [];
    },
});

export const ZyStudio = ZyStudioHeadless.extend({
    addExtensions() {
        return [ZyStudioInstructionNode, ZyStudioNode];
    },
});

export default ZyStudio;
